import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  url() {
    return faker.datatype.number(10);
  },

  partnerType() {
    const options = ['Buy', 'Download', 'Streaming'];

    return faker.helpers.arrayElement(options);
  },

  afterCreate(product, server) {
    product.update({
      category: server.create('category', 'shop'),
    });
  },
});
